<div class="website-translations-page">
  @if (isWebsitesLoading) {
    <section class="page-card card">
      <div class="card-body py-5 text-center">
        <div class="spinner-border text-primary" role="status"></div>
        <p class="mt-3 mb-0">Loading websites...</p>
      </div>
    </section>
  } @else if (loadError && websites.length === 0) {
    <app-api-load-error
      title="Could not load translations"
      [message]="loadError"
      retryLabel="Retry"
      (retry)="ngOnInit()"
    ></app-api-load-error>
  } @else {
    <section class="page-card card website-translations-page__shell">
      <div class="card-body website-translations-page__body">
        <header class="website-translations-page__header">
          <div>
            <h2 class="section-title mb-0 bw-title-with-info">
              Translations
              <app-info-tooltip compact placement="right" text="Manage website translation labels, then use the same key on builder nodes through the inspector."></app-info-tooltip>
            </h2>
          </div>

          <div class="website-translations-page__actions">
            <select
              class="form-select"
              [ngModel]="selectedWebsitePublicId || ''"
              (ngModelChange)="selectWebsite($event)"
            >
              @for (website of websites; track trackWebsite($index, website)) {
                <option [value]="website.publicId">{{ website.name }}</option>
              }
            </select>
            <button type="button" class="btn btn-outline-secondary" [disabled]="!selectedWebsitePublicId || isTranslationsLoading" (click)="loadTranslations()">Reload</button>
            <button type="button" class="btn btn-primary" [disabled]="!selectedWebsitePublicId || isSaving" (click)="saveTranslations()">
              {{ isSaving ? 'Saving...' : 'Save translations' }}
            </button>
          </div>
        </header>

        @if (saveMessage) {
          <div class="alert mb-0" [class.alert-info]="!saveMessage.toLowerCase().includes('must') && !saveMessage.toLowerCase().includes('invalid')" [class.alert-danger]="saveMessage.toLowerCase().includes('must') || saveMessage.toLowerCase().includes('invalid')">
            {{ saveMessage }}
          </div>
        }

        @if (loadError && websites.length > 0) {
          <app-api-load-error
            title="Could not load translations"
            [message]="loadError"
            retryLabel="Retry"
            (retry)="loadTranslations()"
          ></app-api-load-error>
        } @else if (isTranslationsLoading) {
          <div class="website-translations-page__loading">
            <div class="spinner-border text-primary" role="status"></div>
            <span>Loading translation catalog...</span>
          </div>
        } @else if (selectedWebsite) {
          <div class="website-translations-page__toolbar">
            <div class="website-translations-page__language-list">
              @for (language of languages; track trackLanguage($index, language)) {
                <span class="website-translations-page__language-chip">
                  {{ language.toUpperCase() }}
                  <button type="button" aria-label="Remove language" (click)="removeLanguage(language)">x</button>
                </span>
              }
            </div>

            <div class="website-translations-page__inline-form">
              <input class="form-control" [(ngModel)]="newLanguage" placeholder="de" />
              <button type="button" class="btn btn-outline-primary" (click)="addLanguage()">Add language</button>
              <input class="form-control" [(ngModel)]="newKey" placeholder="home.hero.title" />
              <button type="button" class="btn btn-outline-primary" (click)="addEntry()">Add key</button>
            </div>
          </div>

          <div class="website-translations-page__table-wrap">
            <table class="table align-middle mb-0 website-translations-page__table">
              <thead>
                <tr>
                  <th class="website-translations-page__key-col">Key</th>
                  @for (language of languages; track trackLanguage($index, language)) {
                    <th>{{ language.toUpperCase() }}</th>
                  }
                  <th>Notes</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (entries.length === 0) {
                  <tr>
                    <td [attr.colspan]="languages.length + 3">
                      <div class="website-translations-page__empty">
                        Add the first key, for example <strong>home.hero.title</strong>, then put that same key on a text node in the builder inspector.
                      </div>
                    </td>
                  </tr>
                } @else {
                  @for (entry of entries; track trackEntry($index, entry); let entryIndex = $index) {
                    <tr>
                      <td>
                        <input class="form-control website-translations-page__key-input" [(ngModel)]="entry.key" placeholder="section.key" />
                      </td>
                      @for (language of languages; track trackLanguage($index, language)) {
                        <td>
                          <textarea class="form-control website-translations-page__translation-input" rows="2" [(ngModel)]="entry.translations[language]"></textarea>
                        </td>
                      }
                      <td>
                        <input class="form-control" [(ngModel)]="entry.notes" placeholder="Optional context" />
                      </td>
                      <td class="text-end">
                        <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeEntry(entryIndex)">Delete</button>
                      </td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </section>
  }
</div>
